import { createContext, useContext } from 'react';

export const RumContext = createContext(null);

export const useRum = () => {
  return useContext(RumContext);
};
